import bitwiseAnd64Bit from './bitwiseAnd64Bit';
import * as txpConstants from '../../helpers/TxpConstants';

const compareEntityNamesMap = (entityNamesMap: number, entityMapValue: number) => {
    return bitwiseAnd64Bit(entityNamesMap, entityMapValue) === entityMapValue;
};

// Checks if entityNamesMap is travel entity
export function isTravelEntity(entityNamesMap: number): boolean {
    return (
        isFlightEntity(entityNamesMap) ||
        isRentalEntity(entityNamesMap) ||
        isEntityContainsLodging(entityNamesMap) ||
        isUnsuccessfulFlightEntity(entityNamesMap) ||
        isUnsuccessfulRentalEntity(entityNamesMap) ||
        isUnsuccessfulLodgingEntity(entityNamesMap)
    );
}

// Checks if entityNamesMap is flight entity
export function isFlightEntity(entityNamesMap: number): boolean {
    return compareEntityNamesMap(entityNamesMap, txpConstants.FLIGHTS_ENTITY_NAMES_MAP_VALUE);
}

// Checks if entityNamesMap is lodging entity
export function isEntityContainsLodging(entityNamesMap: number): boolean {
    return compareEntityNamesMap(entityNamesMap, txpConstants.LODGING_ENTITY_NAMES_MAP_VALUE);
}

// Checks if entityNamesMap is rental entity
export function isRentalEntity(entityNamesMap: number): boolean {
    return compareEntityNamesMap(entityNamesMap, txpConstants.RENTAL_CAR_ENTITY_NAMES_MAP_VALUE);
}

// Checks if entityNamesMap is package entity
export function isPackageEntity(entityNamesMap: number): boolean {
    return compareEntityNamesMap(entityNamesMap, txpConstants.PACKAGE_ENTITY_NAMES_MAP_VALUE);
}

// Checks if entityNamesMap is dining entity
export function isDiningEntity(entityNamesMap: number): boolean {
    return compareEntityNamesMap(entityNamesMap, txpConstants.DINING_ENTITY_NAMES_MAP_VALUE);
}

// Checks if entityNamesMap is event entity
export function isEventEntity(entityNamesMap: number): boolean {
    return compareEntityNamesMap(entityNamesMap, txpConstants.EVENTS_ENTITY_NAMES_MAP_VALUE);
}

// Checks if entityNamesMap is invoice entity
export function isInvoiceEntity(entityNamesMap: number): boolean {
    return compareEntityNamesMap(entityNamesMap, txpConstants.INVOICE_ENTITY_NAMES_MAP_VALUE);
}

// Checks if entityNamesMap is service reservation entity
export function isServiceReservationEntity(entityNamesMap: number): boolean {
    return compareEntityNamesMap(
        entityNamesMap,
        txpConstants.SERVICE_RESERVATION_ENTITY_NAMES_MAP_VALUE
    );
}

// Checks if entityNamesMap is an unsuccessful flight entity
export function isUnsuccessfulFlightEntity(entityNamesMap: number): boolean {
    return compareEntityNamesMap(
        entityNamesMap,
        txpConstants.UNSUCCESSFUL_FLIGHTS_ENTITY_NAMES_MAP_VALUE
    );
}

// Checks if entityNamesMap is an unsuccessful lodging entity
export function isUnsuccessfulLodgingEntity(entityNamesMap: number): boolean {
    return compareEntityNamesMap(
        entityNamesMap,
        txpConstants.UNSUCCESSFUL_LODGING_ENTITY_NAMES_MAP_VALUE
    );
}

// Checks if entityNamesMap is an unsuccessful rental entity
export function isUnsuccessfulRentalEntity(entityNamesMap: number): boolean {
    return compareEntityNamesMap(
        entityNamesMap,
        txpConstants.UNSUCCESSFUL_RENTAL_ENTITY_NAMES_MAP_VALUE
    );
}
